<!--
功能: 人脸识别

属性: 无
SLOT: 无

事件:
colseFaceModal: 对话框变化时，参数 true 或 false

案例:
    <FaceRecognition v-if="faceRecognition" @colseFaceModal="colseFaceModal"/>
-->

<template>
    <div class="face" style="display: none">
        <!-- 人脸识别 -->
        <Modal ref="faceModal" v-model="faceInfoModal" :title="getTitle()" :closable="false" :mask-closable="false" footer-hide @on-visible-change="colseFaceModal" class="mooc-charge-face-modal">
            <div id="picture">
                <!-- <div>
                    <img :src="faceInfo.head_img_url" v-show="faceInfo.head_img_url && !isVideo"  class="old-image">
                    <p v-show="faceInfo.head_img_url && !isVideo">本人照片</p>
                </div> -->
                <div v-show="isVideo" width="200" height="200" class="video-dev">
                    <img v-show="!spinShow" src = "/static/img/touxiang.png">
                    <video id="snapVideo" width="200" height="200" style="object-fit: cover;" playsinline autoplay></video>
                </div>
                <div>
                    <img v-show="!isVideo" id="previewImage" style="object-fit: cover;" :src="faceInfo.imgSrc">
                    <p v-show="!isVideo">实拍照片</p>
                </div>
                <Spin size="large" fix v-if="spinShow"></Spin>
            </div>
            <p v-show="isVideo" class="tips">{{faceInfo.msg}}</p>
            <!-- <p v-show="isVideo" >根据《网络助学综合评价》规定，考生须承诺所采集图像为本人图像。所采图像仅用于确保学习的真实性和有效性，平台不会泄露个人隐私信息。</p> -->
            <p v-show="isVideo" >按照人社适岗培训要求，从2021年3月1日开始对学习过程进行防挂机检测。</p>
            <!-- <p v-show="state == 0" style="color:red;" >人脸识别失败可跳过，但学习是否有效由人工审核决定。</p> -->
            <Button v-show="state == 2 " ghost class="face-btn-go" type="primary" @click="faceCancel()">跳过</Button>
            <Button v-show="state == 1 " class="face-btn" type="primary" @click="snap()">{{faceInfo.btnText}}</Button>
        </Modal>
        <Modal v-model="msgModal" class="mooc-charge-msg-modal" :title="faceInfo.msgTitle" :closable="false" footer-hide :mask-closable="false">
                    <Alert v-if="!isMobile" type="error" show-icon >
                        <Icon type="md-sad" slot="icon" size="35" color="red" />
                        <template slot="desc">
                            {{faceInfo.msgContent}}<a v-show="isDetail" @click="detail()">查看详情</a>
                        </template>
                    </Alert>
                    <div class="errorCamera" v-else>
                        <p>
                            1、找到手机上的“设置”，并点击打开。<br />
                            2、点击“应用设置”。<br />
                            3、选择“授权管理”点击。<br />
                            4、点击“应用权限管理”。<br />
                            5、选择APP，然后就可以对APP的各项权限进行管理控制了，调用摄像头的权限、启用录音的权限等。
                        </p>

                    </div>
                    <!-- <Button v-show="client.skip == 1" ghost class="face-btn-go" type="primary" @click="msgModalCancel()">跳过</Button> -->
            </Modal>
        <Modal v-model="iframeModal" class="mooc-charge-iframe-modal" :title="faceInfo.msgTitle" width="605" footer-hide :mask-closable="false">
                <iframe v-if="faceInfo.iframeSrc" frameborder="no" border="0" marginwidth="0" name="showHere" style="width: 570px; height: 520px;" :src="faceInfo.iframeSrc"></iframe>
        </Modal>
    </div>
</template>

<script>
import GuangYuanDao from '@/../public/static/js/dao/GuangYuanDao';

export default {
    props: {
        // faceInfo : { type: Object, required: true  }, // 人脸识别配置
    },
    data() {
        return {
            state         : 1,
            title         : 1,
            spinShow      : false, // 加载动画
            msgModal      : false, // 人脸识别错误提示
            iframeModal   : false, // 摄像头启动失败引用 iframeModal 提示
            isDetail      : false, // 摄像头启动失败是否需要查看详情
            faceInfoModal : false, // 人脸识别 modal 弹窗
            faceTask      : null, // 人脸识别认证定时任务
            isVideo       : true, // 判断是否需要拍照
            isFaceloading  : false, // 人脸识别中
            faceCount     : 0,    // 人脸识别次数
            faceErrorCount: 0,    // 人脸识别失败次数
            startTime     : 0,    // 递增方式的定时时间 (单位: 分钟)
            bizCode       : '', // bizCode 用于提交人脸识别接口
            expiresTime   : 0,  // 有效期，单位：分钟
            faceInfo               : {
                btnText            : '拍照',
                msg                : '请将脸部正对识别框！',
                head_img_url       : '', // 接口返回的头像
                imgSrc             : '', // 调用接口的照片
                data_time          : '', // 调用人脸识别的时间戳
                state              : false, // 人脸识别是否验证成功
                msgTitle           : '', // 摄像头调用失败标题
                msgContent         : '', // 摄像头调用失败提示信息
                iframeSrc          : '', // iframeSrc
                tryCount           : 1,  // 失败跳过次数, 默认为 1 (-1 则为不允许跳过)
            },
        };
    },
    created() {
        const sUserAgent = navigator.userAgent.toLowerCase();
        console.log('sUserAgentFace', sUserAgent);
        this.isMobile = sUserAgent.match(/mobile/i) == 'mobile';
    },
    mounted() {
        this._imgShot = new ImageSnapshot('#previewImage', $('#picture'), 200, 200);
        if (this.videoOnHook == 1 && this.triggerType != 0) {
            var questData = this.$store.state.questData;
            let isModel = Utils.getCookie(questData.resCode + this.videoOnHook);
            if (isModel) {
                this.getMediaDevice();
            }
        }
    },
    computed: {
        // 触发方式, 0 = 固定次数, 1 = 固定时间, 2 = 每次递增
        triggerType() {
            return this.$store.state.recordConfig.triggerType;
        },
        // 触发的值，根据类型 triggerType 来设置：当 triggerType = 0 时，表示是按照次数来，当 triggerType = 1 或者 triggerType = 2 时，表示时按照分钟来
        triggerValue() {
            return this.$store.state.recordConfig.triggerValue;
        },
        // 视频首次开始观看时人脸识别, false = 不需要, true = 需要
        videoStartFaceOnce() {
            return this.$store.state.videoStartFaceOnce;
        },
        // 是否人脸识别防挂机
        videoOnHook() {
            return this.$store.state.recordConfig.videoOnHook;
        },
    },
    methods: {
        // 弹窗标题
        getTitle() {
            return this.title == 1 ? '人脸识别' : '照片采集';
        },
        // 调用设备方法
        getMediaDevice() {
            // console.log('this.$store.state.isVideoDevice', this.$store.state.isVideoDevice);
            console.log('this.isFaceloading', this.isFaceloading);
            // 查询摄像设备是否使用中, 如果是则进行延迟 5秒再进行人脸识别
            if (this.isFaceloading) {
                setTimeout(() => {
                    this.getMediaDevice();
                }, 5 * 1000);
            } else {
                this.$store.commit('setVideoStartFaceOnce', false);
                this.isFaceloading = true;
                this.$store.commit('setIsFaceloading', true);
                var self = this;
                // 页面加载时调用摄像头
                this._imgShot.readToSnap(function (hasWebcam, isWebcamAlreadyCaptured) {
                    self.chackVidoe(hasWebcam, isWebcamAlreadyCaptured);
                });
            }
        },
        // 当 face 弹窗变化时
        colseFaceModal(value) {
            this.$emit('colseFaceModal', value);
            // 失败次数
            this.faceErrorCount = 0;
            var questData = this.$store.state.questData;
            if (value) {
                if (this.faceTask) clearTimeout(this.faceTask);
                if (this.videoOnHook == 2 && this.triggerType == 0) {
                    Utils.setCookie(questData.resCode + this.videoOnHook, true, 12, '/page/;');
                }
                // 页面加载时调用摄像头
            } else {
                // 人脸识别弹窗
                this.isFaceloading = false;
                this.$store.commit('setIsFaceloading', this.isFaceloading);
                // 关闭摄像设备
                this._imgShot.stopVideo();
                // videoOnHook == 2 人脸识别类型才触发, 触发类型 1, 2 时, 进行定时任务
                if (this.videoOnHook == 2 && (this.triggerType == 1 || this.triggerType == 2)) {
                    this.faceTimedTask();
                } else {
                    Utils.setCookie(questData.resCode + this.videoOnHook, false, 12, '/page/;');
                }
                // // 触发类型为 0 时, 次数未达到固定次数则进行定时任务
                // if (this.triggerType == 0 && this.faceCount < this.triggerValue) {
                //     // this.faceTimedTask();
                // }
                // 失败跳过次数
                // this.faceInfo.tryCount = this.client.min_try_count;
            }
        },
        // 人脸识别定时任务, 根据参数确定 client.test_interval 时间执行一次
        faceTimedTask() {
            var self = this;
            // 1 固定时间 间隔触发 triggerValue 分钟
            if (this.triggerType == 1) {
                self.faceTask = setTimeout(() => {
                    // 进行人脸识别
                    // self.faceCompareConfig();
                    self.getMediaDevice();
                }, self.triggerValue * 60 * 1000);
            }
            // 2 每次递增
            if (this.triggerType == 2) {
                // 计算定时人脸时间
                self.startTime = self.startTime + self.triggerValue;
                self.faceTask = setTimeout(() => {
                    // 进行人脸识别
                    // self.faceCompareConfig();
                    self.getMediaDevice();
                }, self.startTime * 60 * 1000);
            }
        },
        // 开始人脸识别
        start() {
            // 切换章节时重置每次递增参数
            this.startTime = 0;
            if (this.faceTask) clearTimeout(this.faceTask);
            // 进行人脸识别
            // self.faceCompareConfig();
            this.getMediaDevice();
        },
        // 关闭人脸识别弹窗
        faceCancel() {
            this.faceInfoModal = false;
            this.faceErrorCount = 0;
            setTimeout(() => {
                this.faceInfo.msg = '请将脸部正对识别框！';
                this.faceInfo.btnText = '拍照';
                this.isVideo = false;
                // this.faceInfo.head_img_url = ''; // 三方接口返回对比照片
            }, 500);
            // 关闭摄像头
        },
        // 查看详情
        detail() {
            this.iframeModal = true;
        },
        // 点击拍照
        snap() {
            var self = this;
            // 再试一次
            if (!self.isVideo) {
                self.isVideo = true;
                self.state = 1;
                self.faceInfo.msg = '请将脸部正对识别框！';
                Utils.info(self.faceInfo.msg);
                self.faceInfo.btnText = '拍照';
                return;
            }
            // 拍照返回 base64 数据
            self.faceInfo.imgSrc = self._imgShot.snapshot();
            setTimeout(() => {
                self.recognize();
            }, 300);
        },
        // 截图, 判断是否有人脸
        recognize() {
            var self = this;
            self._imgShot.recognizeImage((data) => {
                // 开启加载中
                self.spinShow = true;
                self.isVideo = false; // 拍照完成, 隐藏 video
                // 发起人脸识别
                self.faceCompareConfig();
            });
        },
        // 发起人脸识别
        faceCompareConfig () {
            // 设置参数配置
            var data = this.$store.state.questData;
            data.deviceId = Utils.getUUID();
            var self = this;

            // 发起人脸识别
            GuangYuanDao.invokeFaceCompareConfig(data, (resData) => {
                if (resData && resData.code == 200) {
                    const result = resData.data;
                    // console.log('发起人脸识别成功');
                    self.bizCode = result.bizCode; // bizCode 用于提交人脸识别接口
                    self.expiresTime = result.expiresTime; // 有效期，单位：分钟
                    // 人脸识别校验接口
                    self.faceVerify();
                } else {
                    self.spinShow = false;
                    // 失败后继续拍照
                    self.faceInfo.btnText = '再试一次';
                    Utils.error(resData.msg);
                }
            });
        },
        // 调用后台接口验证人脸
        faceVerify() {
            var self = this;
            var data = this.$store.state.questData;
            data.bizCode = self.bizCode;
            data.compareMode = 2;
            data.target = self.faceInfo.imgSrc.replace('data:image/png;base64,', '');
            data.videoStudyTime = this.$store.state.currentTime;
            data.deviceId = Utils.getUUID();

            // self.$Message.success('人脸对比通过');
            // // 成功
            // self.state = 2;
            // // 人脸识别成功次数 +1;
            // self.faceCount++;
            // // 1 秒后自动关闭
            // setTimeout(() => {
            //     // 如果弹窗打开, 则关闭
            //     if (self.faceInfoModal) self.faceCancel();
            // }, 1000);
            // self.spinShow = false;

            // console.log('data-1', data);
            // 验证人脸
            GuangYuanDao.invokeFaceCompare(data, (resData) => {
                data.target = '';
                // console.log('data-2', data);
                if (resData && resData.code == 200) {
                    self.$Message.success('人脸对比通过');
                    // 成功
                    self.state = 2;
                    // 人脸识别成功次数 +1;
                    self.faceCount++;
                    // 1 秒后自动关闭
                    setTimeout(() => {
                        // 如果弹窗打开, 则关闭
                        if (self.faceInfoModal) self.faceCancel();
                    }, 1000);
                } else {
                    // 人脸识别失败次数 +1;
                    self.faceErrorCount++;
                    Utils.error(resData.msg);
                    // 失败后继续拍照
                    self.faceInfo.btnText = '再试一次';
                }
                self.spinShow = false;
            });
        },
        // 检查摄像头是否存在可用
        chackVidoe(hasWebcam, isWebcamAlreadyCaptured) {
            if (!!window.ActiveXObject || 'ActiveXObject' in window) { // 判断当前为 ie 浏览器
            // console.log('!!window.ActiveXObject || ActiveXObject in window', !!window.ActiveXObject || 'ActiveXObject' in window);
                this.faceInfoModal = false;
                this.faceInfo.msgTitle = '请更换浏览器';
                this.faceInfo.msgContent = '您的浏览器无法支持继续学习，推荐使用谷歌浏览器。如果您使用的是360浏览器，请更换为极速模式，然后刷新页面。';
                this.faceInfo.iframeSrc = 'https://hbilearning.edu-edu.com.cn/download/hb/videohelp/isie.html';
                this.msgModal = true;
                this.isDetail = true;
                clearTimeout(this.faceTask);
            } else if (!hasWebcam) { // 判断不存在存在摄像头设备
            // console.log('!window.hasWebcam', !hasWebcam);
                this.faceInfoModal = false;
                this.faceInfo.msgTitle = '未检测到摄像头';
                this.faceInfo.msgContent = '请安装好摄像头然后刷新页面。';
                this.msgModal = true;
                clearTimeout(this.faceTask);
            } else if (!isWebcamAlreadyCaptured) { // 判断摄像头设备调用失败
            // console.log('!window.isWebcamAlreadyCaptured', !isWebcamAlreadyCaptured);
                this.faceInfoModal = false;
                this.faceInfo.msgTitle = '调用摄像头失败';
                this.faceInfo.msgContent = '请允许浏览器使用摄像头。';
                this.faceInfo.iframeSrc = 'https://hbilearning.edu-edu.com.cn/download/hb/videohelp/isprohibit.html';
                this.msgModal = true;
                this.isDetail = true;
                clearTimeout(this.faceTask);
            } else {
            // 需要拍照, 人脸识别
                if (!this.faceInfoModal) this.faceInfoModal = true;
                this.faceInfo.msg = '请将脸部正对识别框！';
                this.faceInfo.btnText = '拍照';
                this.state = 1;
                this.isVideo = true;
            // 设置人脸识别进行中
            // 设置设备使用中
            // this.$store.commit('setVideoDevice', true);
            }
            this.isVideo = true;
        },
    },
    // 组件关闭
    destroyed() {
        // 关闭摄像设备
        this._imgShot.stopVideo();
        clearTimeout(this.faceTask);
        console.log('人脸识别组件关闭');
    },
};
</script>

<style lang="scss">
.face {

}
.mooc-charge-face-modal {
    .ivu-modal-body {
        text-align: center;

    }
    .tips {
        color: #333333 ;
        font-size: 16px;
        font-weight: bold;
    }
    p {
        color    : #666666;
        font-size: 12px;
        margin   : 10px auto;
    }

    #picture {
        display        : flex;
        justify-content: center;
        margin         : 20px auto;

        .video-dev {
            width   : 200px;
            height  : 200px;
            position: relative;

            img {
                position   : absolute;
                bottom     : 0;
                left       : 50%;
                width      : 200px;
                margin-left: -100px;
                z-index    : 11;
            }
        }
    }

    .face-btn {
        margin          : 10px 10px 0 10px;
        width           : 88px;
        height          : 32px;
        color           : #fff;
        background-color: #2e8ded;
        border-color    : #2e8ded;
        font-size       : 14px;
        span {
            text-align: center;
        }
    }
    .face-btn-go {
        margin   : 10px 10px 0 10px;
        width    : 88px;
        font-size: 14px;
        height   : 32px;
        border-color    : #2e8ded;
        span {
            text-align: center;
        }
    }
    // .old-image {
    //     width: 200px;
    //     height: 200px;
    //     margin-right: 10px;
    // }
}

.mooc-charge-msg-modal {
    .ivu-modal-body {
        text-align: center;
    }
    .ivu-alert-error {
        border: 1px solid #f4f9f700;
        background-color: #f4f9f700;
    }
    .ivu-alert {
        margin: 0 0 0 -20px;
    }
    .face-btn-go {
        margin   : 10px 10px 0 10px;
        width    : 88px;
        font-size: 14px;
        height   : 32px;
        border-color    : #2e8ded;
        span {
            text-align: center;
        }
    }
    .errorCamera {
        text-align: left;
    }
}

</style>
